import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { InputNumericComponent } from './input-numeric.component';

@NgModule({
    imports: [MatFormFieldModule, MatInputModule, ReactiveFormsModule, CommonModule],
    declarations: [InputNumericComponent],
    exports: [InputNumericComponent],
})
export class InputNumericModule {}
